/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ state: NonNullable<unknown> }} Sound_Pretty_Toad_TreasureInputs */

const fr_sound_pretty_toad_treasure = /** @type {(inputs: Sound_Pretty_Toad_TreasureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La séance a été rendue ${i?.state}`)
};

/**

* @param {Sound_Pretty_Toad_TreasureInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const sound_pretty_toad_treasure = /** @type {((inputs: Sound_Pretty_Toad_TreasureInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sound_Pretty_Toad_TreasureInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_sound_pretty_toad_treasure(inputs)
});